'use strict';
class Calculator {
    constructor() {
        this.coPerSquareMeter = [52.605, 68, 25.0803];
        this.resultingConcreteArray = [17000, 15000, 10000];
        this.assumptionOfFloorThicknessArray = [0.17, 0.15, 0.1];
        this.resultArray = [82, 26667, 13017, 80, 13017, 13017, 50, 7684, 0, 30, 7684, 8];
        this.resultTotalValue = 0;
        this.resultReductionTotalValue = 0;
        this.inputValue = 100000;
        this.activeTab = 0;
        this.columnsData = [
            {
                column_id: 0,
                title: 'Conventional <br> Mesh Reinforced',
                co_per_square_meter: 68,
                work_days_required: 82,
                steel_joints_required: 26667,
                resulting_concrete: 1700,
                floor_thickness: 0.15, // 0.17
                carbon_credits: 'No',
                day_variable: 250,
                day_variable_x: 3,
                day_variable_y: 4,
                day_variable_add: 2,
                steel_joints_variable: 900,
                steel_joints_variable_x: 240,
                steel_joints_variable_sqrt: false
            },
            {
                column_id: 1,
                title: 'Standard SFRC',
                co_per_square_meter: 52.605,
                work_days_required: 80,
                steel_joints_required: 13017,
                resulting_concrete: 1500,
                floor_thickness: 0.15,
                carbon_credits: 'Optional',
                day_variable: 250,
                day_variable_x: 3,
                day_variable_y: 4,
                day_variable_add: 0,
                steel_joints_variable: 900,
                steel_joints_variable_x: 120,
                steel_joints_variable_sqrt: false
            },
            {
                column_id: 2,
                title: 'PrīmX SFRSSC',
                co_per_square_meter: 25.0803,
                work_days_required: 50,
                steel_joints_required: 17684,
                resulting_concrete: 1000,
                floor_thickness: 0.1,
                carbon_credits: 'Optional',
                day_variable: 250,
                day_variable_x: 4,
                day_variable_y: 5,
                day_variable_add: 0,
                steel_joints_variable: 2500,
                steel_joints_variable_x: 200,
                steel_joints_variable_sqrt: true
            },
            {
                column_id: 100,
                title: 'PrīmX Pure',
                co_per_square_meter: 8,
                work_days_required: 30,
                steel_joints_required: 7684,
                resulting_concrete: 1000,
                floor_thickness: 0.1,
                carbon_credits: 'Optional',
                day_variable: 250,
                day_variable_x: 4,
                day_variable_y: 5,
                day_variable_add: 0,
                steel_joints_variable: 2500,
                steel_joints_variable_x: 200,
                steel_joints_variable_sqrt: true
            }
        ];
        this.mainColumnData = {
            co_per_square_meter: 8,
        };
        this.calculateForm = document.querySelector('#calculate-form');
        if (!this.calculateForm)
            return;
        this.inputSquareMeters = this.calculateForm.querySelector('input[name="square-meters"]');
        this.rangeSquareMeters = this.calculateForm.querySelector('input[type="range"]');
        this.resultColumns = document.querySelectorAll('[data-calculate]');
        this.resultTotal = document.querySelector('[data-calculate-block-result]');
        this.resultReduction = document.querySelector('[data-calculate-reduction-block-result]');
        this.radioButtons = document.querySelectorAll('.radio-calculator-buttons button');
        this.radioTabs = document.querySelectorAll('.radio-calculator-tab');
        this.addEventListeners();
        this.setupData();
        this.calculate();
    }
    updateColumnView(data) {
        const columnId = data['column_id'];
        const columnTitles = document.querySelectorAll(`[data-column-title="${columnId}"]`);
        const columnCO = document.querySelector(`[data-column-co="${columnId}"]`);
        const columnWorkDays = document.querySelector(`[data-column-work-days="${columnId}"]`);
        const columnSteelJoints = document.querySelector(`[data-column-steel-joints="${columnId}"]`);
        const columnCarbonCredits = document.querySelector(`[data-column-carbon-credits="${columnId}"]`);
        columnTitles.forEach((title) => {
            title.innerHTML = data['title'];
        });
        columnCO.innerText = parseInt(data['co_per_square_meter']).toString();
        columnWorkDays.innerText = data['work_days_required'];
        columnSteelJoints.innerText = data['steel_joints_required'];
        columnCarbonCredits.innerText = data['carbon_credits'];
    }
    setupData() {
        const self = this;
        Object.keys(this.columnsData).forEach((key) => {
            const column = this.columnsData[key];
            self.updateColumnView(column);
        });
    }
    calculate() {
        const self = this;
        const inputSqrt = Math.sqrt(self.inputValue);
        self.columnsData.forEach((column) => {
            const workDays = (column['floor_thickness'] * self.inputValue / column['day_variable'] / column['day_variable_x'] * column['day_variable_y']) + column['day_variable_add'];
            let steelJoints = self.inputValue / column['steel_joints_variable'] * column['steel_joints_variable_x'];
            if (column['steel_joints_variable_sqrt']) {
                steelJoints -= inputSqrt;
            }
            if (column['column_id'] === self.activeTab) {
                const mainColumnCoPerSquare = (self.mainColumnData['co_per_square_meter'] * self.inputValue);
                self.resultTotalValue = (column['co_per_square_meter'] * self.inputValue) - mainColumnCoPerSquare;
                const totalCoForFloor = column['co_per_square_meter'] * self.inputValue;
                self.resultReductionTotalValue = totalCoForFloor - mainColumnCoPerSquare - mainColumnCoPerSquare;
            }
            column['work_days_required'] = parseInt(Math.round(workDays).toString());
            column['steel_joints_required'] = parseInt(Math.round(steelJoints).toString());
            self.updateColumnView(column);
        });
        self.resultTotal.innerText = parseInt(self.resultTotalValue.toString()).toLocaleString('fi-FI');
        self.resultReduction.innerText = parseInt(self.resultReductionTotalValue.toString()).toLocaleString('fi-FI');
    }
    submitValue() {
        // Find email if exists
        let email = document.querySelector('input[name="email"]');
        const emailValue = email ? email.value : '';
        const formData = new FormData(this.calculateForm);
        formData.append('square-meters', this.inputValue.toString());
        formData.append('email', emailValue);
        const options = {
            method: 'POST',
            contentType: 'application/x-www-form-urlencoded',
            body: formData
        };
        fetch('/wp-admin/admin-ajax.php?action=submit_calculate', options)
            .then(response => response.json())
            .then(data => {
        });
    }
    addEventListeners() {
        const self = this;
        let userInputTimeout = null;
        this.rangeSquareMeters.addEventListener('input', (e) => {
            this.inputValue = parseFloat(this.rangeSquareMeters.value);
            this.inputSquareMeters.value = this.rangeSquareMeters.value;
            this.calculate();
            if (userInputTimeout) {
                clearTimeout(userInputTimeout);
            }
            userInputTimeout = setTimeout(() => {
                this.submitValue();
            }, 500);
        });
        this.inputSquareMeters.addEventListener('change', (e) => {
            this.inputValue = parseFloat(this.inputSquareMeters.value);
            if (this.inputValue < 3000) {
                this.inputSquareMeters.value = '3000';
                this.inputValue = 3000;
            }
            this.rangeSquareMeters.value = this.inputValue.toString();
            this.calculate();
            this.submitValue();
        });
        this.radioButtons.forEach((button) => {
            button.addEventListener('click', (e) => {
                e.preventDefault();
                this.radioButtons.forEach((rButton) => {
                    rButton.classList.remove('is-active');
                });
                self.activeTab = parseInt(button.getAttribute('data-tab-id'));
                this.radioTabs.forEach((tab) => {
                    tab.classList.add('d-none');
                    if (parseInt(tab.getAttribute('data-col-tab')) === self.activeTab) {
                        tab.classList.remove('d-none');
                    }
                });
                button.classList.add('is-active');
                self.calculate();
                self.submitValue();
            });
        });
    }
}
const calculator = new Calculator();
